import { render, staticRenderFns } from "./Rentals.vue?vue&type=template&id=05db2e80&scoped=true&"
import script from "./Rentals.vue?vue&type=script&lang=js&"
export * from "./Rentals.vue?vue&type=script&lang=js&"
import style0 from "./Rentals.vue?vue&type=style&index=0&id=05db2e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db2e80",
  null
  
)

export default component.exports